// Mirrors the date/time formatting used by the trade tab's order tables
// (OpenOrdersTableGenerator.formatDate) — SGT, "Month D, YYYY" + "H:MM AM/PM" —
// split into two functions so admin tables can render Date and Time as
// separate columns instead of one combined string.

export const formatDateSGT = (value) => {
    if (value == null) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleString("en-SG", {
        month: "long",
        day: "numeric",
        year: "numeric",
        timeZone: "Asia/Singapore",
    });
};

export const formatTimeSGT = (value) => {
    if (value == null) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleTimeString("en-SG", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: "Asia/Singapore",
    });
};
